<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="addurl"
      >
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="form-group align-items-center">
            <label for="inputs_name">
              {{ $t("name") }}
            </label>
            <app-input
              id="inputs_name"
              type="text"
              v-model="inputs.name"
              :required="true"
            />
          </div>
        </div>
        <div class="col-lg-12 col-md-12" v-if="showEditor == true">
          <div class="form-group align-items-center">
            <label for="inputs_description">
              {{ $t("description") }}
            </label>
            <app-input
              type="text-editor"
              :required="true"
              :label="$t('description')"
              v-model="inputs.description"
            />
          </div>  
        </div>
      </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosPost,axiosGet } from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      showEditor: false,
      addurl: actions.SERVICE_STORE,
      preloader: false,
      inputs: {},
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
    }
  },
  methods: {
    submit() {

      if (this.modalTitle == "Edit") {

        let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });

        axiosPost(actions.SERVICE_UPDATE, formData)
          .then((res) => {
            
            this.afterSuccess(res);
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            this.preloader = false;
            this.closeModal();
          });
      } else {

        let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key, this.inputs[key]);
        });
        this.save(formData);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
      this.showEditor = true;
    },
  },
};
</script>
